import type { AdminLeadItem } from '@/domains/admin/types';
import type { PublicDiagnosticResult } from '@/domains/results/types';

export const MOCK_ADMIN_USER = {
  id: 'usr-admin-001',
  email: 'israel@decolacont.com.br',
  name: 'Israel Costa',
  role: 'admin' as const,
  isActive: true,
};

export const MOCK_INACTIVE_ADMIN_USER = {
  id: 'usr-admin-002',
  email: 'inativo@decolacont.com.br',
  name: 'Administrador Inativo',
  role: 'admin' as const,
  isActive: false,
};

export const MOCK_LEADS: AdminLeadItem[] = [
  {
    id: 'lead-001',
    publicToken: 'a1b2c3d4-e5f6-4a7b-8c9d-0123456789ab',
    name: 'Mariana Souza',
    email: 'mariana.souza@souzacontabilidade.com.br',
    phone: '(11) 98765-4321',
    companyName: 'Souza & Associados Contabilidade',
    overallScore: 48,
    overallTierKey: 'building',
    categoryScores: {
      positioning: 33, // Exceção 1 acionada
      founder_authority: 55,
      digital_assets: 44,
      distribution: 22,
      commercial_conversation: 67,
      customer_experience: 67,
    },
    primaryPriorityKey: 'positioning',
    hasRetentionRisk: false,
    commercialStatus: 'novo',
    notes: 'Vinda do Instagram após palestra sobre posicionamento. Escritório em expansão com 8 funcionários.',
    origin: 'instagram_direct',
    utmCampaign: 'palestra_sp_mar2026',
    createdAt: '2026-09-24T18:30:00Z',
    history: [
      {
        id: 'hist-001',
        leadId: 'lead-001',
        changedBy: 'Israel Costa',
        field: 'commercial_status',
        newValue: 'novo',
        timestamp: '2026-09-24T18:30:00Z',
      },
    ],
  },
  {
    id: 'lead-002',
    publicToken: 'b2c3d4e5-f6a7-4b8c-9d0e-123456789abc',
    name: 'Carlos Eduardo Mendes',
    email: 'carlos@mendesconsultiva.cnt.br',
    phone: '(21) 97654-3210',
    companyName: 'Mendes Contabilidade Consultiva',
    overallScore: 72,
    overallTierKey: 'conversations',
    categoryScores: {
      positioning: 89,
      founder_authority: 78,
      digital_assets: 67,
      distribution: 55,
      commercial_conversation: 67,
      customer_experience: 78,
    },
    primaryPriorityKey: 'distribution',
    hasRetentionRisk: false,
    commercialStatus: 'em_contato',
    notes: 'Interesse forte na mentoria DecolaCont. Já atua com nicho de médicos.',
    origin: 'bio_instagram',
    utmCampaign: 'organico',
    createdAt: '2026-09-24T16:15:00Z',
    history: [
      {
        id: 'hist-002a',
        leadId: 'lead-002',
        changedBy: 'Israel Costa',
        field: 'commercial_status',
        newValue: 'novo',
        timestamp: '2026-09-24T16:15:00Z',
      },
      {
        id: 'hist-002b',
        leadId: 'lead-002',
        changedBy: 'Israel Costa',
        field: 'commercial_status',
        oldValue: 'novo',
        newValue: 'em_contato',
        timestamp: '2026-09-24T17:00:00Z',
      },
    ],
  },
  {
    id: 'lead-003',
    publicToken: 'c3d4e5f6-a7b8-4c9d-0e1f-23456789abcd',
    name: 'Renata Oliveira',
    email: 'renata@oliveirasantosgestao.com.br',
    phone: '(31) 99887-7665',
    companyName: 'Oliveira & Santos Gestão Contábil',
    overallScore: 22,
    overallTierKey: 'housekeeping',
    categoryScores: {
      positioning: 22,
      founder_authority: 11,
      digital_assets: 22,
      distribution: 11,
      commercial_conversation: 33,
      customer_experience: 33, // Risco de retenção acionado (<40)
    },
    primaryPriorityKey: 'positioning',
    hasRetentionRisk: true,
    commercialStatus: 'qualificado',
    notes: 'Alerta de risco de retenção. Perdeu clientes antigos por falha de alinhamento e comunicação.',
    origin: 'evento_presencial',
    utmCampaign: 'conescap_2026',
    createdAt: '2026-09-24T14:00:00Z',
    history: [
      {
        id: 'hist-003a',
        leadId: 'lead-003',
        changedBy: 'Israel Costa',
        field: 'commercial_status',
        newValue: 'novo',
        timestamp: '2026-09-24T14:00:00Z',
      },
      {
        id: 'hist-003b',
        leadId: 'lead-003',
        changedBy: 'Israel Costa',
        field: 'commercial_status',
        oldValue: 'novo',
        newValue: 'qualificado',
        timestamp: '2026-09-24T15:30:00Z',
      },
    ],
  },
  {
    id: 'lead-004',
    publicToken: 'd4e5f6a7-b8c9-4d0e-1f2a-3456789abcde',
    name: 'Felipe Vasconcelos',
    email: 'felipe@vasconceloscont.com.br',
    phone: '(41) 98456-1122',
    companyName: 'Vasconcelos Soluções Contábeis',
    overallScore: 84,
    overallTierKey: 'structured',
    categoryScores: {
      positioning: 100,
      founder_authority: 89,
      digital_assets: 78,
      distribution: 78,
      commercial_conversation: 78,
      customer_experience: 89,
    },
    primaryPriorityKey: 'digital_assets',
    hasRetentionRisk: false,
    commercialStatus: 'convertido',
    notes: 'Presença muito madura. Contratou assessoria avançada.',
    origin: 'indicacao_parceiro',
    utmCampaign: 'parceiros_banco',
    createdAt: '2026-09-23T11:20:00Z',
    history: [
      {
        id: 'hist-004',
        leadId: 'lead-004',
        changedBy: 'Israel Costa',
        field: 'commercial_status',
        oldValue: 'qualificado',
        newValue: 'convertido',
        timestamp: '2026-09-23T16:00:00Z',
      },
    ],
  },
  {
    id: 'lead-005',
    publicToken: 'e5f6a7b8-c9d0-4e1f-2a3b-456789abcdef',
    name: 'Juliana Prado',
    email: 'juliana@pradocontabilidademedica.com',
    phone: '(81) 99123-4567',
    companyName: 'Prado Contabilidade Médica',
    overallScore: 39,
    overallTierKey: 'scattered',
    categoryScores: {
      positioning: 67,
      founder_authority: 44,
      digital_assets: 33,
      distribution: 11,
      commercial_conversation: 33, // Exceção 2 acionada (conversa < 40 e dist menor)
      customer_experience: 44,
    },
    primaryPriorityKey: 'commercial_conversation',
    hasRetentionRisk: false,
    commercialStatus: 'sem_interesse',
    notes: 'Disse que está focada no fechamento do ano fiscal agora. Retornar em 60 dias.',
    origin: 'anuncio_meta',
    utmCampaign: 'campanha_diagnostico_video1',
    createdAt: '2026-09-22T09:40:00Z',
    history: [
      {
        id: 'hist-005',
        leadId: 'lead-005',
        changedBy: 'Israel Costa',
        field: 'commercial_status',
        oldValue: 'novo',
        newValue: 'sem_interesse',
        timestamp: '2026-09-22T11:00:00Z',
      },
    ],
  },
];

export const MOCK_SAMPLE_RESULT: PublicDiagnosticResult = {
  publicToken: 'a1b2c3d4-e5f6-4a7b-8c9d-0123456789ab',
  leadFirstName: 'Mariana',
  overallScore: 48,
  overallTier: {
    min: 45,
    max: 64,
    key: 'building',
    label: 'Presença em construção',
  },
  categoryScores: {
    positioning: 33,
    founder_authority: 55,
    digital_assets: 44,
    distribution: 22,
    commercial_conversation: 67,
    customer_experience: 67,
  },
  primaryPriority: {
    key: 'positioning',
    name: 'Posicionamento',
  },
  secondaryPriority: {
    key: 'distribution',
    name: 'Distribuição',
  },
  hasRetentionRisk: false,
  algorithmVersion: 'v1.0.0',
  completedAt: '2026-09-24T18:30:00Z',
};
